var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "mb-20" }, [
    _c("div", { staticClass: "disp-flex mb-10" }, [
      _c("div", { staticClass: "user-activity" }, [
        _c("div", { staticStyle: { width: "60px" } }, [
          _c(
            "div",
            { staticClass: "user-block" },
            [
              _c("avatar", {
                attrs: {
                  username:
                    _vm.loggedInUserInfo && _vm.loggedInUserInfo.username
                      ? _vm.loggedInUserInfo.username
                      : ""
                }
              })
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "textarea-wrapper", staticStyle: { width: "100%" } },
        [
          _c("el-input", {
            attrs: {
              placeholder: _vm.$t("whatLikeToSay"),
              type: "textarea",
              rows: 2
            },
            on: { focus: _vm.handleFocus, blur: _vm.handleBlur },
            model: {
              value: _vm.noteMessage,
              callback: function($$v) {
                _vm.noteMessage = $$v
              },
              expression: "noteMessage"
            }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _vm.hasFocus
      ? _c("div", { staticClass: "disp-flex" }, [
          _c("div", { staticStyle: { width: "60px" } }),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "LoadingButton",
                {
                  attrs: { size: "mini", type: "primary", execute: _vm.onSave }
                },
                [_vm._v(_vm._s(_vm.$t("save")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "info" },
                  on: { click: _vm.onCancel }
                },
                [_vm._v(_vm._s(_vm.$t("cancel")))]
              )
            ],
            1
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }